import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import * as actions from 'global/actions/passwordActions';
import CurvedContainer from '../../components/CurvedContainer';
import { colors } from 'global/colors';
import { Wrapper, Container, Input, Header, Button, InfoText, Form } from '../../components';
import { BottomContainer } from './styles';
import { useActions } from 'hooks/useActions';
import { Images } from 'util/images';
import { useAppContext } from 'hooks/useContext';
import * as strings from './strings';
import apiErrors from 'api/apiErrors';

export default React.memo(() => {
  const { loading, error, success } = useSelector((state) => state.managePassword);
  const { clearError, clearState, resetPassword } = useActions(actions);

  const [email, setEmail] = useState('');
  const { language } = useAppContext();

  useEffect(() => {
    return () => clearState();
  }, [clearState]);

  return (
    <Wrapper>
      <CurvedContainer bottom image={Images.art} height={110} />
      <Container color={colors.lightGray} half column>
        <Header>{strings.header[language]}</Header>
        <Form onChange={() => error && clearError()} onSubmit={() => resetPassword(email)}>
          <Input
            autoFocus
            type="email"
            value={email}
            placeholder={strings.emailPlaceholder[language]}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button primary type="submit" disabled={!email || error}>
            {strings.header[language]}
          </Button>
        </Form>
        <BottomContainer>
          <InfoText error={error} success={success}>
            {loading ? strings.loadingLabel[language] : ''}
            {apiErrors?.[error?.name]?.[language] ?? error}
            {success ? strings.successLabel[language] : ''}
          </InfoText>
        </BottomContainer>
      </Container>
    </Wrapper>
  );
});
